import axios from "axios";

// Cliente axios dedicado para llamadas públicas (sin sesión). Se usa una
// instancia propia (sin interceptors) en vez del wrapper `methods` de
// `utils/axios.ts` o del singleton global de `axios`: ese singleton tiene un
// interceptor de respuesta 401 que intenta `validateSession()` y reintenta la
// request con un Bearer token de `localStorage` si el navegador tiene uno de
// una sesión previa, lo que rompería la garantía de que los flujos públicos
// (guest) sean siempre anónimos.
const publicClient = axios.create();

export default publicClient;
